import { API } from "@/main";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  getAllLayers({ commit }) {
    return new Promise((resolve, reject) => {
      API.layer.getAll(
        result => {
          let layers = result.data.data;
          resolve(layers);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  getLayersMenu({ commit }, filter = null) {
    return new Promise((resolve, reject) => {
      API.layer.getAsMenu(
        filter,
        result => {
          let layersMenu = result.data.data;
          resolve(layersMenu);
        },
        error => {
          reject(error);
        }
      );
    });
  }
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/layers.js